module.exports = __webpack_public_path__ + "static/map01-cfb990258b88476b15313105c3bdf266.png";